import React from 'react';
import Plot from 'react-plotly.js';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const styles = () => ({
  plot: {
    width: '100%',
    height: '100%',
  },
});

class PlotMany extends React.Component {
  render() {
    const {
      classes, data, axesOptions, showLegend,
    } = this.props;
    const {
      xTitle, xScaleType, yTitle, yScaleType,
    } = axesOptions;
    const items = data.map((item) => {
      return {
        x: item.x,
        y: item.y,
        name: item.title,
        type: 'scatter',
        mode: 'lines+markers',
        marker: {
          color: item.color,
          symbol: 'circle',
          opacity: '0.8',
          size: 8,
        },
      };
    });
    return (
      <Plot
        className={classes.plot}
        data={items}
        useResizeHandler
        config={{
          displayModeBar: true,
          autosizable: false,
          displaylogo: false,
          fillFrame: false,
          editable: false,
          showTips: true,
        }}
        layout={{
          xaxis: {
            title: xTitle,
            type: xScaleType,
            autorange: true,
          },
          yaxis: {
            title: yTitle,
            type: yScaleType,
            autorange: true,
          },
          showlegend: showLegend,
          legend: {
            x: 0,
            y: 1,
          },
        }}
      />
    );
  }
}

PlotMany.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  data: PropTypes.arrayOf(PropTypes.shape({
    x: PropTypes.arrayOf(Number).isRequired,
    y: PropTypes.arrayOf(Number).isRequired,
    title: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
  }).isRequired).isRequired,
  axesOptions: PropTypes.shape({
    xTitle: PropTypes.string.isRequired,
    yTitle: PropTypes.string.isRequired,
    xScaleType: PropTypes.string.isRequired,
    yScaleType: PropTypes.string.isRequired,
  }).isRequired,
  showLegend: PropTypes.bool.isRequired,
};

export default withStyles(styles)(PlotMany);
